import { create } from "zustand";

export type Toast = { id: number; tone: "info" | "success" | "error"; text: string };

let next = 1;

export const useToasts = create<{ items: Toast[] }>(() => ({ items: [] }));

export function toast(text: string, tone: Toast["tone"] = "info", ms = 3500) {
  const id = next++;
  useToasts.setState((s) => ({ items: [...s.items.slice(-4), { id, tone, text }] }));
  setTimeout(() => useToasts.setState((s) => ({ items: s.items.filter((t) => t.id !== id) })), ms);
}
